import React from 'react';
import { Row, Col } from 'antd';

import CouponItemCard from '../CouponItemCard';

const foodList = [
  { name: 'bank1' },
  { name: 'bank2' },
  { name: 'bank3' },
  { name: 'bank4' },
  { name: 'bank5' },
  { name: 'bank6' },
  { name: 'bank7' }
];

const CouponsList: React.FC = (Props: any) => {
  return (
    <Row gutter={[16, 24]}>
      {foodList.map((item) => (
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={4}>
          <CouponItemCard key={item.name} />
        </Col>
      ))}
    </Row>
  );
};

export default CouponsList;
